<template lang="jade">
   div.Wrapper
     div.Message.Message--info(":skin"="skins.messages")
       i.fa.fa-info(style="margin-right: 15px")
       span.Message__body {{{ fdata.value }}}
</template>

<script>
 import { skins } from 'src/vuex/getters'

 export default {
   props: {
     fdata: {
       type: Object
     }
   },
   vuex: {
     getters: {
       skins
     }
   }
 }
</script>



// WEBPACK FOOTER //
// rawHtml.vue?280f6406